/* ========================================
   page-machine-model.liquid behavior
   - Color swatch → hero image, price, MSRP, thumbnails
   - Contact modal open/close
   - Feature carousel (dots + arrows)
   Loaded with `defer`, so DOM is parsed before this runs.
   All logic is idempotent and bails early if its targets aren't on the page.
   ======================================== */
(function () {
  'use strict';

  function initSwatchesAndModal() {
    var swatches = document.querySelectorAll('.machine-swatch');
    var heroImg = document.getElementById('machine-hero-img');
    var priceDisplay = document.getElementById('machine-price-display');
    var msrpDisplay = document.getElementById('machine-msrp-display');
    var thumbsWrap = document.getElementById('machine-hero-thumbnails');

    function buildThumbnails(swatch) {
      if (!thumbsWrap) return;
      thumbsWrap.innerHTML = '';
      var images = [];
      if (swatch.dataset.image) images.push(swatch.dataset.image);
      if (swatch.dataset.image2) images.push(swatch.dataset.image2);
      if (swatch.dataset.image3) images.push(swatch.dataset.image3);

      images.forEach(function (src, i) {
        var btn = document.createElement('button');
        btn.className = 'machine-thumb' + (i === 0 ? ' is-active' : '');
        btn.dataset.src = src;
        var img = document.createElement('img');
        img.src = src.replace('width=1200', 'width=120');
        img.alt = '';
        btn.appendChild(img);
        btn.addEventListener('click', function () {
          if (heroImg) heroImg.src = src;
          thumbsWrap.querySelectorAll('.machine-thumb').forEach(function (t) { t.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
        thumbsWrap.appendChild(btn);
      });

      if (images.length <= 1) {
        thumbsWrap.style.display = 'none';
      } else {
        thumbsWrap.style.display = 'flex';
      }
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');
        if (heroImg && swatch.dataset.image) {
          heroImg.src = swatch.dataset.image;
        }
        if (priceDisplay && swatch.dataset.price) {
          priceDisplay.textContent = 'Starting at ' + swatch.dataset.price + '*';
        }
        if (msrpDisplay && swatch.dataset.msrp) {
          msrpDisplay.textContent = swatch.dataset.msrp;
        }
        buildThumbnails(swatch);
      });
    });

    // Initialize thumbnails for the first active swatch
    var activeSwatch = document.querySelector('.machine-swatch.is-active');
    if (activeSwatch) buildThumbnails(activeSwatch);

    var modal = document.getElementById('machine-contact-modal');
    var openBtn = document.getElementById('machine-contact-btn');
    var closeBtn = modal ? modal.querySelector('.machine-modal-close') : null;

    if (openBtn && modal) {
      openBtn.addEventListener('click', function () {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) {
          modal.classList.remove('is-open');
          document.body.style.overflow = '';
        }
      });
    }
  }

  function initFeatureCarousel() {
    var carousel = document.querySelector('.machine-features-carousel');
    if (!carousel) return;
    var slides = carousel.querySelectorAll('.machine-fc-slide');
    var total = slides.length;
    if (!total) return;
    var current = 0;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      slides.forEach(function (s) { s.classList.remove('is-active'); });
      slides[index].classList.add('is-active');
      // Keep dot state in sync within the active slide
      var activeDots = slides[index].querySelectorAll('.machine-fc-dot');
      activeDots.forEach(function (dot, di) {
        dot.classList.toggle('is-active', di === index);
      });
      current = index;
    }

    carousel.addEventListener('click', function (e) {
      var arrow = e.target.closest('.machine-fc-arrow');
      var dot = e.target.closest('.machine-fc-dot');
      if (arrow) {
        if (arrow.getAttribute('aria-label') === 'Next') {
          goTo(current + 1);
        } else {
          goTo(current - 1);
        }
      } else if (dot) {
        goTo(parseInt(dot.dataset.goto, 10));
      }
    });
  }

  function init() {
    initSwatchesAndModal();
    initFeatureCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
